import { render, staticRenderFns } from "./DashboardPerformanceGroupNew.vue?vue&type=template&id=9d82eaa6&scoped=true"
import script from "./DashboardPerformanceGroupNew.vue?vue&type=script&lang=js"
export * from "./DashboardPerformanceGroupNew.vue?vue&type=script&lang=js"
import style0 from "./DashboardPerformanceGroupNew.vue?vue&type=style&index=0&id=9d82eaa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d82eaa6",
  null
  
)

export default component.exports